import { render, staticRenderFns } from "./c-SNPMB-Materi.vue?vue&type=template&id=ab379c30&scoped=true&"
import script from "./c-SNPMB-Materi.vue?vue&type=script&lang=js&"
export * from "./c-SNPMB-Materi.vue?vue&type=script&lang=js&"
import style0 from "./c-SNPMB-Materi.vue?vue&type=style&index=0&id=ab379c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab379c30",
  null
  
)

export default component.exports